<template>
  <div class="alert-message mb-15">
    <div class="sidebar" :class="typeSideBar"></div>
    <el-card class="box-card" :class="typeAlert">
      <span>{{ message }}</span>
    </el-card>
  </div>
</template>

<script>
  export default {
    props: ['type', 'message'],
    computed: {
      typeSideBar: function() {
        switch(this.type) {
          case 'danger':
            return 'sidebar-danger';
          case 'completed':
            return 'sidebar-completed';
        }
      },
      typeAlert: function() {
        switch(this.type) {
          case 'danger':
            return 'alert-danger';
          case 'completed':
            return 'alert-completed';
        }
      }
    }
  }
</script>
